import React from 'react';
import { getUserImageUrl } from '../utils/imageHelper';

interface ImagePreviewModalProps {
  isOpen: boolean;
  imageUrl?: string | null;
  name?: string;
  secondaryImageUrl?: string | null;
  secondaryName?: string | null;
  onClose: () => void;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  imageUrl,
  name,
  secondaryImageUrl,
  secondaryName,
  onClose,
}) => {
  if (!isOpen) return null;

  const resolvedUrl = getUserImageUrl(imageUrl);
  const resolvedSecondaryUrl = getUserImageUrl(secondaryImageUrl);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content image-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h3>{secondaryName && name ? `${name} & ${secondaryName}` : name || 'Ảnh'}</h3>
          </div>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close preview">
            ×
          </button>
        </div>

        <div className="modal-body image-preview-modal__body">
          {resolvedUrl || resolvedSecondaryUrl ? (
            <div className="image-preview-modal__pair">
              {resolvedUrl ? (
                <div className="image-preview-modal__item">
                  <img src={resolvedUrl} alt={name ? `Ảnh của ${name}` : 'Ảnh đại diện'} className="image-preview-modal__image" />
                  {name && <p className="image-preview-modal__caption">{name}</p>}
                </div>
              ) : (
                <div className="image-preview-modal__item">
                  <div className="image-preview-modal__empty">
                    <i className="fas fa-user"></i>
                    <p>Không có ảnh đại diện</p>
                  </div>
                </div>
              )}

              {resolvedSecondaryUrl ? (
                <div className="image-preview-modal__item">
                  <img
                    src={resolvedSecondaryUrl}
                    alt={secondaryName ? `Ảnh của ${secondaryName}` : 'Ảnh đại diện'}
                    className="image-preview-modal__image"
                  />
                  {secondaryName && <p className="image-preview-modal__caption">{secondaryName}</p>}
                </div>
              ) : (
                <div className="image-preview-modal__item">
                  <div className="image-preview-modal__empty">
                    <i className="fas fa-user"></i>
                    <p>Không có ảnh đại diện</p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="image-preview-modal__empty">
              <i className="fas fa-user"></i>
              <p>Không có ảnh đại diện</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
